/* 'Barrel' of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './header.interceptor';
import { ServerErrorsInterceptor } from './server-error.interceptor';
export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ServerErrorsInterceptor,
        multi: true
    }

    /**
     * You can add as many interceptors as you want.
     * The order matters cause it will be applied according to which placed first, so the first interceptor will be applied first and so on
     */
];
